import React from 'react';
import PropTypes from 'prop-types';
import { Typography, IconButton, Box, Grid } from '@material-ui/core';
import CopyIcon from '../../../../../common/icons/CopyIcon';
import { useCodeStyles } from './styles';

const CodeInfo = ({ ...props }) => {
  const { title, info, onShare } = props;
  const classes = useCodeStyles();
  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      justify="center"
    >
      <Typography className={classes.title}> {title} </Typography>
      <Box display="flex" alignItems="center">
        <Typography className={classes.number}> {info} </Typography>
        <IconButton onClick={() => onShare(info)} data-cy={'iconButton'}>
          <CopyIcon color="#6A148E" size="20px" />
        </IconButton>
      </Box>
    </Grid>
  );
};

CodeInfo.propTypes = {
  title: PropTypes.string,
  info: PropTypes.string,
  onShare: PropTypes.func,
};

export default CodeInfo;
